/**
 * Application Constants
 */

export const DATE_RANGES = {
  SEVEN_DAYS: '7d',
  THIRTY_DAYS: '30d',
  ALL: 'all',
} as const;

export const USER_STATUS = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
} as const;

export const BOOKING_STATUS = {
  PENDING: 'pending',
  COMPLETED: 'completed',
  CANCELLED: 'cancelled',
} as const;

export const ITEMS_PER_PAGE = 10;

/**
 * PRODUCTION NOTE: Store in environment variables
 */
export const API_BASE_URL = '/api';

/**
 * Mock credentials for development
 * PRODUCTION: Remove these and use real authentication
 */
export const MOCK_CREDENTIALS = {
  email: 'admin@looksadmin.com',
  password: 'admin123',
};
